module.exports = __webpack_public_path__ + "fonts/BwModelica-Medium.cf02791c.ttf";